export const GET_SHOWTIMES = 'GET_SHOWTIMES';
export const ADD_SHOWTIME = 'ADD_SHOWTIME';
export const UPDATE_SHOWTIME = 'UPDATE_SHOWTIME';
export const DELETE_SHOWTIME = 'DELETE_SHOWTIME';
export const TOGGLE_DIALOG = 'TOGGLE_DIALOG';
export const SELECT_SHOWTIMES = 'SELECT_SHOWTIMES';
export const SELECT_ALL_SHOWTIMES = 'SELECT_ALL_SHOWTIMES';
